// MultipleSelect.styles.js
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  selectRoot: {
    minHeight: '37.63px',
    padding: '10.5px 14px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
    fontSize: '14px',
    overflowX: 'hidden',
  },
  menuItem: {
    fontSize: '14px',
  },
  chipsContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: 4,
    maxWidth: '100%',
    overflow: 'hidden',
  },
  chipWrapper: {
    display: 'inline-flex',
    minWidth: 0,
    maxWidth: '100%',
  },
  chip: {
    maxWidth: '100%',
  },
  chipLabel: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  measureContainer: {
    position: 'absolute',
    visibility: 'hidden',
    pointerEvents: 'none',
    height: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
